import React from 'react'
import { object, number } from 'prop-types'
import { connect } from 'react-redux'
import { handleUpdateCategory } from '../../../../store/Actions/SpiActions'
import CategoryInner from './CategoryInner'
import { categoryClass } from './CategoryClass'

const Category = ({
  category,
  currentCategory,
  categoryId,
  updateCategory,
}) => (
  <li
    className={categoryClass(currentCategory, categoryId)}
    onClick={() => updateCategory([category.description, category.id])}
  >
    <CategoryInner description={category.description} />
  </li>
)

Category.propTypes = {
  category: object.isRequired,
  currentCategory: number.isRequired,
  categoryId: number.isRequired,
}

const mapStateToProps = ({ spi }) => ({
  currentCategory: parseInt(spi.category[1], 10),
})

const mapDispatchToProps = dispatch => ({
  updateCategory: value => dispatch(handleUpdateCategory(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Category)



// WEBPACK FOOTER //
// ./src/components/Elements/Sidebar/Categories/Category.jsx